module.exports = __webpack_public_path__ + "static/media/earlexFlyer1Back.1fbe5c2e.jpg";